import { css, styled } from '@styles/theme'

const Grid = styled('div', {
	display: 'grid',
	gridTemplateColumns: '1fr',
	gap: '16px',

	'@sm': {
		gap: '24px',
	},

	'@md': {
		gridTemplateColumns: 'repeat(2, 1fr)',
	},

	'@lg': {
		gap: '32px',
	},

	'@xl': {
		gridTemplateColumns: 'repeat(3, 1fr)',
	},
})

export const SimulateStyles = {
	container: css({
		background: '$neutral30',
		padding: '24px',
		width: '100%',
		display: 'flex',
		flexDirection: 'column',

		'@sm': {
			padding: '8px 24px 8px 24px',
		},

		'@md': {
			padding: '8px 65px 8px 61px',
		},
	}),

	titleIndex: css({
		display: 'flex',
		justifyContent: 'space-between',
		flexDirection: 'column',
		marginBottom: '41px',

		div: {
			marginTop: '10px',
		},

		'@sm': {
			marginTop: '40px',
		},

		'@md': {
			marginTop: '40px',
			flexDirection: 'row',

			div: {
				display: 'flex',
				gap: '28px',
				marginTop: '0px',
				flexDirection: 'row',
			},
		},
	}),

	title: css({
		display: 'flex',
		justifyContent: 'space-between',
		flexDirection: 'column',
		marginTop: '19px',
		marginBottom: '32px',

		div: {
			display: 'flex',
			gap: '5px',
			marginTop: '10px',
			flexDirection: 'column-reverse',
			border: '20px solid',
		},

		h1: {
			lineHeight: 'normal',

			'@md': {
				lineHeight: '19px',
			},
		},

		'@md': {
			flexDirection: 'row',

			div: {
				display: 'flex',
				gap: '28px',
				marginTop: '0px',
				flexDirection: 'row',
			},
		},
	}),

	ContainerFocus: styled('div', {
		variants: {
			open: {
				true: {
					display: 'block',
				},
				false: {
					display: 'none',
				},
			},
		},
	}),

	buttonsFocus: css({
		display: 'flex',
		justifyContent: 'space-between',
		marginTop: '32px',
		marginBottom: '71px',
	}),

	buttonSelectSimulate: css({
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignitems: 'center',
		padding: '15px 16px',
		height: '50px',
		width: '100%',
		maxWidth: '100%',

		background: '$neutral10',
		border: '1px solid $neutral50',
		borderRadius: '12px',
		marginBottom: '36px',

		'@md': {
			maxWidth: '327px',
		},

		h6: {
			_font: 'normal',
			fontWeight: '400',
			fontSize: '14px',
			lineHeight: 'unset',
			color: '$neutal150',
		},

		svg: {
			width: '18px',
			height: '20px',
		},

		'&:hover': {
			borderColor: '$blue20',
			h6: {
				color: '$blue20',
			},
			svg: {
				color: '$blue20',
			},
		},
	}),

	ContainerGrid: styled(Grid, {
		'& > *': {
			flexBasis: '100%',
		},
		'@lg': {
			'& > *': {
				flexBasis: '49%',
			},
		},
		'@xl': {
			'& > *': {
				flexBasis: '31%',
			},
		},
	}),
}
